import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Activity, CheckCircle2, Clock } from 'lucide-react';
import api from '@/lib/api';

function timeAgo(iso) {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;
  const mins = Math.floor((Date.now() - then) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
}

export default function JobHealthCard() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/jobs/health');
        setJobs(data?.jobs || []);
      } catch {
        setJobs([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Card data-testid="job-health-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Activity size={18} className="text-emerald-600" />
          Background Jobs Health
        </CardTitle>
        <p className="text-sm text-muted-foreground">Last successful run of each scheduled task.</p>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="text-sm text-muted-foreground py-4">Loading…</div>
        ) : (
          <div className="divide-y divide-border rounded-lg border border-border">
            {jobs.map((j) => {
              const ago = timeAgo(j.last_successful_run);
              const ok = !!j.last_successful_run;
              return (
                <div key={j.key} className="flex items-center justify-between gap-3 px-4 py-3" data-testid={`job-health-${j.key}`}>
                  <div className="min-w-0">
                    <div className="font-medium text-sm flex items-center gap-2">
                      <CheckCircle2 size={14} className={ok ? 'text-emerald-600' : 'text-muted-foreground/40'} />
                      {j.label}
                    </div>
                    <div className="text-xs text-muted-foreground truncate">{j.description}</div>
                  </div>
                  <div className="text-right shrink-0">
                    {ok ? (
                      <>
                        <div className="text-xs font-semibold text-emerald-700 flex items-center gap-1 justify-end">
                          <Clock size={12} /> {ago}
                        </div>
                        <div className="text-[10px] text-muted-foreground">{new Date(j.last_successful_run).toLocaleString()}</div>
                      </>
                    ) : (
                      <span className="text-xs text-muted-foreground italic">Never run</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
